import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// components
import PageTitle from "./../../../components/common/pageTitle/PageTitle";

// utils
import toast from "@src/utils/toast";
import useUrlQueryString from "../../../utils/hooks/useUrlQueryString";
import { setInPath, setOrigin } from "@src/@slice/recommendHallSlice";
import { HOSTNAME, isExternalUrl } from "@src/utils";

// API
import { getRecommendHallList } from "@src/api/recommend/recommend";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { closeWebview } from "@src/utils/route";
import StartRollingImage from "./_component/StartRollingImage";
import StopRecommend from "./_component/StopRecommend";
import Blank from "@src/components/common/blank/Blank";

const Start = () => {
  const navigate = useNavigate();
  const query = useUrlQueryString();
  const origin = query.get("origin");
  const inpath = query.get("inpath");
  const dispatch = useDispatch();
  const goNext = () => {
    navigate("/recommend/hall/style");
  };

  const [showStopModal, setShowStopModal] = useState(false);
  useEffect(() => {
    if (inpath) {
      dispatch(setInPath({ inpath: inpath.toUpperCase() }));
    }
    if (origin) {
      dispatch(setOrigin({ origin: origin.substring(0, 10) }));
    }
  }, []);
  // useEffect(() => {
  //   getRecommendHallList()
  //     .then((res) => {
  //       if (res.data.item.length > 0) {
  //         toast.showToast("😀 신청하신 웨딩홀 추천 리스트가 있어요!", {
  //           customToastId: "recommendHallList",
  //           isAutoRemove: false,
  //           onClick: () => {
  //             window.location.href = isExternalUrl(
  //               `${HOSTNAME}/my-records/recommend?tab=all&hidetop=true`,
  //             );
  //           },
  //           bottomPosition: 100,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.showErrorSnackbar("추천 리스트 조회 실패", {
  //         customToastId: "recommendHallList",
  //         removeTime: 3000,
  //         bottomPosition: 100,
  //       });
  //     });

  //   return () => {
  //     toast.removeToast("recommendHallList");
  //   };
  // }, []);

  return (
    <div className="recommend-hall-page recommend-hall-start">
      <CustomHeader goBack={closeWebview} close={closeWebview} />
      <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} />
      <div className="recommend-hall-page-body">
        <PageTitle title={`나에게 딱 맞는 \n웨딩홀 리스트 받아보기`} />
        <p className="recommend-hall-start-desc">
          결혼 준비 첫걸음 웨딩홀부터
          <br />
          준비는 간편하게 혜택은 풍성하게
        </p>
        <StartRollingImage />
        <Blank height={300} />
      </div>
      <div className="recommend-hall-page-footer">
        <button onClick={goNext} className="btn btn-giant btn-red500 btn-full">
          맞춤 웨딩홀 추천 받기
        </button>
      </div>
    </div>
  );
};

export default Start;
